import Search from "../form/Search";
import LimitSelect from "./LimitSelect";

const TableControls = ({ limit, totalDocs, onLimitChange, onSearch }) => {
  return (
    <div className="flex items-center gap-4">
      <div className="w-36">
        <LimitSelect
          value={limit || 100}
          allValue={totalDocs}
          onChange={onLimitChange}
        />
      </div>
      <div className="w-72">
        <Search placeholder="Search here" search={onSearch} />
      </div>
    </div>
  );
};

export default TableControls;
